import type { SectionsConfig } from '@backoffice-frontend/authenticated-app-view'
import { useDialog } from '@moia-dev/pace-web'
import { useEffect } from 'react'
import { CommandPaletteDialog } from './CommandPaletteDialog'

type CommandPaletteProps = {
  sections: SectionsConfig
}

export const CommandPalette = ({ sections }: CommandPaletteProps) => {
  const { id, isOpen, openDialog, closeDialog } = useDialog()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault()
        openDialog()
        return
      }

      if (event.key === 'Escape' && isOpen) {
        event.preventDefault()
        closeDialog()
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [openDialog, closeDialog, isOpen])

  return (
    <CommandPaletteDialog
      id={id}
      isOpen={isOpen}
      onClose={closeDialog}
      sections={sections}
    />
  )
}
